import React from 'react';
import { useParticipantsStatisticsPair } from 'twain-sport-fe-mono/hooks';
import { IParticipantsPair } from '../../interfaces';
import { Participants } from '../Participants';
import { Grid } from '../Grid';
import classes from './VideoPlayerStatistics.module.scss';

const SHORT_STATISTICS_COUNT = 4;

interface IProps {
    participants: IParticipantsPair;
}

export const VideoPlayerStatistics: React.FC<IProps> = (props) => {
    const statistics = useParticipantsStatisticsPair(props.participants);

    return (
        <>
            <Participants live={false} participants={props.participants} onVideo />
            <div className={classes.body}>
                <Grid statistics={statistics} short rowsAmount={SHORT_STATISTICS_COUNT} />
            </div>
        </>
    );
};
